import { Col, Row } from '@ahmdigital/ui';
import React from 'react';

import { URLS } from '../../../../../../models/url/constants';
import OtherInsuranceContacts from '../../../other-insurance-contacts';
import RelatedQuestions, { RelatedQuestionsProps } from '../../../related-questions';

const relatedQuestions: RelatedQuestionsProps = {
  links: [
    {
      name: 'Life insurance',
      url: URLS.SALES.LIFE_INSURANCE,
    },
    {
      name: 'Travel insurance',
      url: URLS.SALES.TRAVEL_INSURANCE,
    },
    {
      name: 'Car insurance',
      url: URLS.SALES.CAR_INSURANCE,
    },
    {
      name: 'Home and contents insurance',
      url: URLS.SALES.HOME_INSURANCE,
    },
    {
      name: 'Income protection insurance',
      url: URLS.SALES.INCOME_INSURANCE,
    },
  ],
};

const OtherInsurance = () => (
  <>
    <Row isBoxed>
      <Col df>
        <OtherInsuranceContacts />
      </Col>
    </Row>
    <Row isBoxed>
      <Col df>
        <RelatedQuestions {...relatedQuestions} />
      </Col>
    </Row>
  </>
);

export default OtherInsurance;
